module.exports = __webpack_public_path__ + "img/logo-transparent1.e62d4932.png";